import './Spinner.css';

function Spinner(){
    return(
        <>
            <span className='only-spinner'></span>
        </>
    )
}

export default Spinner;
